'use client'

import { useAnalytics } from '@/helpers/telemetry/SegmentAnalytics'
import { trackSignUpStart } from '@/helpers/telemetry/trackSignUpStart'

import { LINKS } from './content'

export type AuthCtaLocation = 'homepage_hero' | 'homepage_cta_band'

/**
 * Mirrors what the global header sends for its Register / Sign in buttons, so sign-ups
 * from this page count the same way in the sign-up funnel and the button-click reports.
 */
export function useAuthCtaTracking(ctaLocation: AuthCtaLocation) {
  const { trackButtonClicked } = useAnalytics()

  return {
    onCreateAccount: () => {
      trackSignUpStart(ctaLocation)
      trackButtonClicked({
        buttonName: 'register_now',
        url: document.URL,
        referrer: document.referrer,
        cta_url: LINKS.signup,
        cta_location: ctaLocation,
      })
    },
    onSignIn: () => {
      trackButtonClicked({
        buttonName: 'sign_in',
        url: document.URL,
        referrer: document.referrer,
        cta_url: LINKS.signin,
        cta_location: ctaLocation,
      })
    },
  }
}
